import React from 'react';
import classNames from 'classnames';
import './RegBadge.css';
import { isRegularPlayer } from '../../containers/StatPage/utils';
import RegBadgeIcon from '../../assets/RegBadgeIcon.png';

type Props = {
  hands: number | null | undefined;
  bb100: number | null | undefined;
  vpip: number | null | undefined;
  pfr: number | null | undefined;
  className?: string;
};

function getRegBadgeTitle(
  hands: number | null | undefined,
  bb100: number | null | undefined,
  vpip: number | null | undefined,
  pfr: number | null | undefined,
) {
  const handsCount = hands ?? 0;
  const isVolumeWinner = handsCount > 30000 && (bb100 ?? 0) > 0;
  const isTightRegular =
    handsCount > 30 &&
    vpip != null &&
    vpip >= 12 &&
    vpip <= 28 &&
    pfr != null &&
    pfr >= 10 &&
    pfr <= 24;

  if (isVolumeWinner && isTightRegular) {
    return `${handsCount} hands, winrate ${bb100} bb100, VPIP ${vpip}%, PFR ${pfr}%`;
  }

  if (isTightRegular) {
    return `${handsCount} hands, VPIP ${vpip}%, PFR ${pfr}%`;
  }

  return `${handsCount} hands, winrate ${bb100} bb100`;
}

const RegBadge = React.memo(({ hands, bb100, vpip, pfr, className }: Props) => {
  if (!isRegularPlayer(hands, bb100, vpip, pfr)) {
    return null;
  }

  const title = getRegBadgeTitle(hands, bb100, vpip, pfr);

  return (
    <span
      className={classNames('RegBadge', className)}
      title={title}
      aria-label={`Regular player — ${title}`}
    >
      <img className="RegBadge__Icon" src={RegBadgeIcon} alt="" aria-hidden="true" />
    </span>
  );
});

export default RegBadge;
